<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="确认"
    cancel-text="取消"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="建设指标" prop="oneTarget">
          <a-input v-model="form.oneTarget" />
        </a-form-model-item>
        <a-form-model-item label="二级指标">
          <a-input v-model="form.twoTarget" />
        </a-form-model-item>
        <a-form-model-item label="指标内涵" prop="content">
          <a-textarea
            v-model="form.content"
            placeholder="请输入指标内涵"
            :auto-size="{ minRows: 4, maxRows: 6 }"
          />
        </a-form-model-item>
        <a-form-model-item label="分数" prop="score">
          <a-input-number
            style="width: 60px"
            id="inputNumber"
            v-model="form.score"
            :min="0"
          />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number
            style="width: 60px"
            id="inputNumber"
            v-model="form.sort"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>
  
<script>
import { postAction, putAction } from "@/api/index";
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        name: "",
        region: undefined,
        date1: undefined,
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      rules: {
        oneTarget: [
          {
            required: true,
            message: "请输入建设指标",
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: "请输入建设内涵",
            trigger: "blur",
          },
        ],
        score: [
          {
            required: true,
            message: "请输入建设内涵",
            trigger: "blur",
          },
        ],
      },
      applyType: 0,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
    };
  },
  methods: {
    init(type, applyType, record) {
      this.type = type;
      this.applyType = applyType;
      this.visible = true;
      if (type == "add") {
        this.form = {};
        this.title = "添加指标";
      } else {
        this.title = "编辑指标";
        this.form = {
          oneTarget: record.oneTarget,
          twoTarget: record.twoTarget,
          content: record.content,
          score: record.score,
          sort: record.sort,
          id: record.id,
        };
      }
    },
    handleCancel() {
      this.visible = false;
    },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.visible = false;

          if (this.type == "add") {
            let params = this.form;
            params.applyType = this.applyType;
            postAction("/lx/lxExpertItem/add", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("addTarget");
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let params = this.form;
            params.applyType = this.applyType;
            putAction("/lx/lxExpertItem/edit", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("编辑成功");
                this.$emit("addTarget");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>
